import {Discipline} from "./Discipline";

export class Credit {
    public type: string;
    public discipline: Discipline;
    public monashUnitCode: string;
    public monashUnitVersion: string;
    public creditPoints: number;
    public unitLevel: string;
    public specifiedCreditType: any;
    public comments: string;

    constructor() {
        this.type = "SPECIFIED_CREDIT";
        this.creditPoints = 0;
        this.specifiedCreditType = null;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/Credit.ts